import React from 'react'

import FormPage from '../FormPage'
import {useNavigate, Link} from "react-router-dom";
import {HistoryOutlined, DeleteOutlined} from "@ant-design/icons";

class AuthDeactivateAccount extends FormPage
{
    static path = '/account/deactivate';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel auth-settings-form';

    /**
     * The title shown on the form
     */
    static FormTitle = "auth.deactivate.title";

    /**
     * The subtitle shown on the form
     */
    static FormSubtitle = "auth.deactivate.subtitle";

    /**
     * The submit button title for the form
     */
    static FormSubmit = false;

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 840;

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
        super(props);

        this.state = {
            ...this.state,
            model: {}
        };
    }

    /**
     * Renders form child elements
     *
     * @returns {Component}
     */
    renderFormChildren()
    {
        return (
            <div className="flex flex-col items-stretch">
                <p className="mt-4 mb-8 text-[15px] leading-relaxed text-black">
                    We're sorry to see you go. You can choose to temporarily
                    deactivate your account, or permanently delete your account
                    and data. Either way, you can always create a new Wripple
                    account if you change your mind.
                </p>

                <div className="flex flex-col items-stretch justify-center gap-6 md:flex-row">
                    <div className="flex flex-1 flex-col items-center rounded-lg border border-light-gray5 p-8 text-center">
                        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-[26px] text-primary">
                            <HistoryOutlined/>
                        </div>
                        <h3 className="mb-3 whitespace-nowrap text-lg font-semibold text-black">
                            Deactivate my account
                        </h3>
                        <p className="mb-6 flex-1 text-sm leading-relaxed text-black">
                            Your account will be deactivated, but you can log
                            back in at any time to reactivate and access your
                            data.
                        </p>
                        <button type="button"
                                disabled={this.state.isDisabled}
                                onClick={() => this.onSubmit()}
                            className="btn btn-primary min-w-[200px] normal-case">
                            Deactivate Account
                        </button>
                    </div>

                    <div className="flex flex-1 flex-col items-center rounded-lg border border-light-gray5 p-8 text-center">
                        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-danger/10 text-[26px] text-danger">
                            <DeleteOutlined/>
                        </div>
                        <h3 className="mb-3 whitespace-nowrap text-lg font-semibold text-black">
                            Deactivate and delete my data
                        </h3>
                        <p className="mb-6 flex-1 text-sm leading-relaxed text-black">
                            Your account and all your data will be permanently
                            deleted. This action cannot be undone.
                        </p>
                        <button type="button"
                                disabled={this.state.isDisabled}
                                onClick={() => this.onSubmit({requests_deletion: true})}
                            className="btn btn-danger min-w-[200px] normal-case">
                            Deactivate &amp; Delete Data
                        </button>
                    </div>
                </div>

                <div className="mt-7 text-center">
                    <Link to={TB.auth().appropriate()} replace={true} disabled={this.state.isDisabled} className="font-semibold text-primary no-underline hover:underline">
                        Cancel and keep my account
                    </Link>
                </div>
            </div>
        );
    }

    /**
     * Overridable method for handling form submit button clicks when form is valid
     *
     * @param {Object} model
     * @returns void
     */
    async onSubmit(params = {})
    {
        let didConfirm;
        if (params.requests_deletion) {
            didConfirm = await TB.alert("error", "Deactivate your account?",
                "You will immediately be logged out and and all your data will be permanently deleted. Note: this action cannot be undone.",
                [
                        {title: 'Yes, continue'},
                        {title: 'Cancel'}
                ]);
        }else {
            didConfirm = await TB.sysAlert(
                'talent.deactivate_account'
            );
        }

        if (!didConfirm) {
            return;
        }

        let didDeactivate = await TB.auth().deactivateAccount(params);

        if(didDeactivate) {
            this.props.navigate(TB.auth().appropriate(), {replace: true})
        }
    }
}

const DeactivateAccount = (props) => {
    const navigate = useNavigate();

    return (
        <AuthDeactivateAccount navigate={navigate}/>
    )
}

export default DeactivateAccount;